import { Alert } from "react-bootstrap"

import { useFetchUserDataQuery } from "../../../app/userApiSlice"
import useAuth from "../../../hooks/useAuth"
import Spinner from "../../../components/Spinner"
import UpdateUserForm from "../components/UpdateUserForm"

const UpdateUserDetailsPage = () => {
  const { uid } = useAuth()
  const {
    data,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error
  } = useFetchUserDataQuery(uid, { skip: !uid })

  if (isLoading || !data) return <Spinner />

  if (isError) {
    console.log(error)
    return <Alert variant="danger">{error || "An unknown error has occurred"}</Alert>
  }

  if (isSuccess) return (
    <div className="w-100">
      <h3 className="mb-4 fw-bold">Update Profile</h3>
      <UpdateUserForm data={data} isFetching={isFetching} />
    </div>
  )


  return null
}
export default UpdateUserDetailsPage